import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
import "./mobile.css";


/**
 * @function InfoAlertView
 * @param {STRING} className - Allows us to pass a unique class to each InfoAlertView. 
 * @param {STRING} icon - Allows us to set the icon id for the SVGAsset.
 * @param {STRING} text - Allows us to set the link text.
 * @param {STRING} data-point - Allows us to set a data-point to the text
 * @returns {React.Component}
 * @example
 * <FormContainer className="some-class">
 *  <FormRowView/>
 * </FormContainer>
 */
export default function InfoAlertView(props) {
  const className = props.className ?? "";
  const icon = props.icon ?? <SVGAsset id="ExclamationMarkIcon" />;
  const text = props.text ?? "Some into alert view text.";
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};

  return (
    <div className={ `info-alert-view flex-container flex-horizontal info-container content-container ${ className }` } { ...dataPoint }>
        <div className="set-width">
        { icon }
        </div>
        <div className="flex-width">
            <p>{ text }</p>
        </div>
    </div>                
  );
}